export const badgeTheme = {
    variants: {
        subtle: {
            color: 'white',
            bg: 'tryt.primary-1',
            fontFamily: 'fonts',
        },
    },
}
